var site = site || {};

site.direction = site.direction || {};

(function ($) {
  var $header = $('.site-header');
  var modMaxWidth = 1024;
  var modMinWidth = 768;
  var scalables = [];

  function _verticallyCenterSlideAbstract() {
    // Only do this if browser doesn't support the modern, css-based way to
    // vertically center stuff.
    if (Modernizr.csstransforms) {
      return;
    }

    $('.homepage-hero__abstract--default-y-pos').each(function () {
      var h = $(this).height();

      if (h) {
        $(this).height(h);
        $('.homepage-hero__abstract__inner', this).css('marginTop', -(h / 2));
      }
    });
  }

  function _resize() {
    var $modules = $('.homepage-hero');
    var wW = $(window).width();

    // If not between the min/max width parameters for scaling:
    if (wW >= modMaxWidth || wW < modMinWidth) {
      // Reset any styles that were scaled:
      _.each(scalables, function (item) {
        var styles = {};

        _.each(item.props, function (prop) {
          styles[prop] = '';
        });
        item.$el.css(styles);
      });

      _verticallyCenterSlideAbstract();

      return;
    }

    // Otherwise, scale each scalable property:
    _.each(scalables, function (item) {
      item.$el.each(function () {
        var styles = {};
        var $el = $(this);
        var originalValues = $el.data('scalable-original-values');

        _.each(item.props, function (prop) {
          if (_.isObject(originalValues) && !_.isUndefined(originalValues[prop])) {
            styles[prop] = (wW * originalValues[prop]) / modMaxWidth;
          }
        });

        $el.css(styles);
      });
    });

    _verticallyCenterSlideAbstract();
  }

  Drupal.behaviors.hpHeroDebugLayer = {
    attach: function (context) {
      var qs = {};
      var hash;
      // console.log('where\'s the grid?');
      var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
      var qsValues = {
        'small': 1,
        'medium': 1,
        'mediumplus': 1,
        'large': 1
      };

      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        qs[hash[0]] = hash[1];
      }

      var size = qs['hp_hero_debug'];

      if (!size || _.isUndefined(qsValues[size])) {
        return;
      }

      $('.homepage-hero__slide', context).prepend('<img class="homepage-hero__debug-layer" src="/media/grid_tools/grid-' + size + '.png" />');
    }
  };

  Drupal.behaviors.hpHero = {
    attach: function (context) {
      $('.homepage-hero', context).each(function () {
        var $module = $(this);
        var $slickWrapper = $('.homepage-hero__inner', $module);
        var $slides = $('.homepage-hero__slide', $slickWrapper);
        var $nav = $('.homepage-hero__nav', $module);
        // Store all the elements that need to scale, which properties need to
        // scale, and what their original values were for the _resize function.
        var modScalableElements = [
          {
            $el: $('.homepage-hero__slide__inner', $module),
            props: ['height']
          },
          {
            $el: $('.homepage-hero__headline', $module),
            props: ['font-size', 'margin-bottom']
          },
          {
            $el: $('.homepage-hero__description', $module),
            props: ['font-size', 'margin-bottom']
          },
          {
            $el: $('.hp_video_slide', $module),
            props: ['height']
          },
          // {
          //   $el: $('.homepage-hero__link', $module),
          //   props: ['font-size']
          // },
          {
            $el: $('.homepage-hero__abstract__inner', $module),
            props: ['padding-top', 'padding-right', 'padding-bottom', 'padding-left']
          },
          {
            $el: $('.homepage-hero__abstract__inner', $module),
            props: ['width']
          }
        ];

        // Store the original values as whatever they currently are now:
        _.each(modScalableElements, function (item, index) {
          // Each property-value pair may be unique per element, so store them
          // on the element itself:
          item.$el.each(function () {
            var $el = $(this);
            var originalValues = $el.data('scalable-original-values') || {};

            _.each(item.props, function (prop, propIndex) {
              var originalValue = $el.css(item.props[propIndex]);

              if (_.isString(originalValue)) {
                originalValue = originalValue.replace('px', '') - 0;
              }

              originalValues[prop] = originalValue;
            });

            $el.data('scalable-original-values', originalValues);
          });
        });

        scalables = scalables.concat(modScalableElements);

        function _setStyles(index) {
          index = index || 0;
          var $slide = $slides.eq(index);

          // The slide can control different header styles
          $header.toggleClass('site-header--bordered', !!$slide.data('header-border'));
          $header.toggleClass('site-header--light', !!$slide.data('header-light'));
          $header.toggleClass('site-header--solid', !!$slide.data('header-solid'));

          // It can also control the color of the carousel arrows
          $module.toggleClass('homepage-hero--light-arrows', !!$slide.data('light-arrows'));
        }

        if ($slides.length > 1) {
          // Hero Video Slide Present : Static Random Slide
          if ($('.hp_video_slide').length) {
            $slickWrapper.slick({
              rtl: site.direction.isRTL,
              arrows: false,
              autoplay: false,
              draggable: false,
              swipe: false,
              lazyLoad: 'ondemand',
              initialSlide: Math.floor(Math.random() * $slides.length),
              onBeforeChange: function (slickSlider, slideIndex, futureSlideIndex) {
                _setStyles(futureSlideIndex);
              },
              onInit: function () {
                _setStyles();
              }
            });
            // Remove other slides for better performance.
            $('.slick-active').ready(function () {
              $('.homepage-hero__slide__inner').each(function (i, obj) {
                if (!$(obj).parent().hasClass('slick-active')) {
                  $(this).addClass('remove-slide');
                }
              });
              $('.remove-slide').remove();
            });
            $('.homepage-hero__nav').hide();
          } else {
            // Regular Carousel No Vid Slide Detected
            $slickWrapper.slick({
              rtl: site.direction.isRTL,
              fade: true,
              autoplay: true,
              autoplaySpeed: 5000,
              pauseOnHover: false,
              prevArrow: $('.slick-prev', $module),
              nextArrow: $('.slick-next', $module),
              onBeforeChange: function (slickSlider, slideIndex, futureSlideIndex) {
                _setStyles(futureSlideIndex);
              },
              onInit: function () {
                _setStyles();
              }
            });

            $('.slick-prev, .slick-next', $module).once('slick-nav-buttons').on('click', function () {
              // Stop autoplay once the user interacts with the carousel
              $slickWrapper.slickPause();
            });
            _resize();
          }
        } else {
          $nav.hide();
        }
      }); // end each
    }
  };

  if (!Modernizr.csstransforms) {
    $(window).on('load', _resize);
  }

  $(window).on('resize-debounced', _resize);

  _resize();
})(jQuery);
